// extracted by mini-css-extract-plugin
export default {"DeliveryFormModal":"DeliveryFormModal_DeliveryFormModal__aOOih"};